import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RestService} from "../../core/services/rest.service";
import {AtividadeNacional} from "../../../classes/atividade.nacional";

@Injectable()
export class AtividadeNacionalService {

  constructor(private restService: RestService){
  }

  buscar(): Observable<AtividadeNacional[]> {
    return this.restService.get("/atividadenacional/buscar", {responseType: AtividadeNacional});
  }

  porContribuinte(): Observable<AtividadeNacional[]> {
    return this.restService.get("/atividadenacional/porContribuinte", {responseType: AtividadeNacional});
  }

}
